module.exports = __webpack_public_path__ + "static/media/slide-3.638ec227.jpg";